var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-card',{staticClass:"text-center mt-3"},[_c('b-card-body',[_c('b-card-title',[_vm._v("表示する内容がありません")]),_vm._v(" "),_c('b-card-text',[_vm._v("クラスを選択してください。期間は選択しなければ全期間のデータを表示できます。")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }